// Small helper for the app's raw-fetch JSON endpoints (checkout, billing).
// These are the sanctioned non-Inertia endpoints; CSRF comes from the
// layout's meta tag.

export interface JsonResult<T> {
  ok: boolean
  status: number
  data: T
}

export async function fetchJson<T = Record<string, unknown>>(
  url: string,
  options: { method?: string; body?: unknown } = {},
): Promise<JsonResult<T>> {
  const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content
  const response = await fetch(url, {
    method: options.method ?? "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrf ?? "",
      Accept: "application/json",
    },
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
    credentials: "same-origin",
  })
  const data = (await response.json().catch(() => ({}))) as T
  return { ok: response.ok, status: response.status, data }
}

export function formatCents(cents: number): string {
  const dollars = cents / 100
  return Number.isInteger(dollars)
    ? `$${dollars.toLocaleString()}`
    : `$${dollars.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}
